// extracted by mini-css-extract-plugin
export default {"disclaimer":"disclaimer_disclaimer__K-CFH","svg":"disclaimer_svg__kW7DG","text":"disclaimer_text__axK6O","close":"disclaimer_close__wScSS"};